module.exports = __webpack_public_path__ + "static/cover-light-75c0e6a7d98aa075c1d247640b7d5db9.jpg";